export default "__VITE_ASSET__B2pJ9Jh2__"